<script setup lang="ts">
  import { Button } from "@/components/ui/button";
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  } from "@/components/ui/dropdown-menu";
  import { MoreHorizontal } from "lucide-vue-next";
  import type { DataTableActionsProps } from "./types";

  defineProps<DataTableActionsProps>();

  const emit = defineEmits<{
    action: [key: string];
  }>();
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="ghost"
        size="icon-sm">
        <span class="sr-only">Open menu</span>
        <MoreHorizontal class="size-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="end"
      class="font-sans text-sm">
      <template
        v-for="action in actions"
        :key="action.key">
        <DropdownMenuSeparator v-if="action.separatorBefore" />
        <DropdownMenuItem
          :disabled="action.disabled"
          :class="['text-sm', action.variant === 'destructive' ? 'text-status-error-strong' : '']"
          @click="!action.disabled && emit('action', action.key)">
          <component
            :is="action.icon"
            v-if="action.icon"
            class="mr-2 h-4 w-4" />
          <div
            v-if="action.hint"
            class="flex flex-col">
            <span>{{ action.label }}</span>
            <span class="text-muted-foreground text-xs">{{ action.hint }}</span>
          </div>
          <template v-else>{{ action.label }}</template>
        </DropdownMenuItem>
      </template>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
